module.exports = {
	"name": "Logitech F310 (DirectInput) Firefox Windows",
	"supported": [
		{
			"id": "046d-c216-Logitech Logitech Dual Action",
			"os": "Linux",
			"browser": "Firefox"
		}
	],
	"axes": {
		"left stick x": {
			"index": 0
		},
		"left stick y": {
			"index": 1
		},
		"dpad x": {
			"index": 4
		},
		"dpad y": {
			"index": 5
		},
		"right stick y": {
			"index": 3
		},
		"right stick x": {
			"index": 2
		}
	},
	"buttons": {
		"a": {
			"index": 1
		},
		"left shoulder": {
			"index": 4
		},
		"right shoulder": {
			"index": 5
		},
		"dpad left": {
			"axis": 4,
			"direction": -1
		},
		"dpad right": {
			"axis": 4,
			"direction": 1
		},
		"dpad up": {
			"axis": 5,
			"direction": -1
		},
		"dpad down": {
			"axis": 5,
			"direction": 1
		},
		"left trigger": {
			"index": 6
		},
		"right trigger": {
			"index": 7
		},
		"b": {
			"index": 2
		},
		"y": {
			"index": 3
		},
		"x": {
			"index": 0
		},
		"back": {
			"index": 8
		},
		"start": {
			"index": 9
		},
		"left stick": {
			"index": 10
		},
		"left stick left": {
			"axis": 0,
			"direction": -1
		},
		"left stick right": {
			"axis": 0,
			"direction": 1
		},
		"left stick up": {
			"axis": 1,
			"direction": -1
		},
		"left stick down": {
			"axis": 1,
			"direction": 1
		},
		"right stick": {
			"index": 11
		},
		"right stick up": {
			"axis": 3,
			"direction": -1
		},
		"right stick down": {
			"axis": 3,
			"direction": 1
		},
		"right stick left": {
			"axis": 2,
			"direction": -1
		},
		"right stick right": {
			"axis": 2,
			"direction": 1
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/html5-gamepad/mappings/logitechf310-directinput-ff-linux.json
// module id = 204
// module chunks = 0